import React from "react";
import { Row, Col, FormGroup } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";

import {
  contractorPersonEmploymentStatusList,
  contractorPersonFormLabel,
  contractorPersonGenderList,
  contractorPersonMedicalCategoryList,
  contractorPersonMedicalEligibilityList,
  contractorPersonMineTagList,
  contractorPersonTrainingDesignationList,
  contractorPersonTrainingEligibilityList,
  contractorPersonTrainingStatus,
} from "../Constant";

import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";

import Label from "app/Components/_form/Label/Label";
import FormInput from "app/Components/_form/FormInput/FormInput";
import InputError from "app/Components/_form/InputError/InputError";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { useTraining } from "app/_helpers/hooks";
import { employeeTrainingDesignationList } from "../../Employee/Constant";
import InitialLocationForm from "../../Employee/Component/InitialLocationForm";
import InitialTrainingForm from "../../Employee/Component/InitialTrainingForm";
import InitialMedicalForm from "../../Employee/Component/InitialMedicalForm";

function ContractorPersonForm({
  id,
  form = {},
  onChange,
  error = {},
  siteList = [],
  contractorList = [],
  previousTraining,
  setPreviousTraining,
  preTrainingErr,
}) {
  const [training, trainingOption] = useTraining("filter[type]=training");

  console.log("formContractor", form);

  const onChangeTraining = (e) => {
    const {
      target: { name, value },
    } = e;
    if (name === "trainingDesignation" && id && form.trainingDesignation !== value) {
      confirmAlert({
        title: "Training required for new designation",
        message: "Do you want to proceed?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              onChange(e);
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    }
  };

  const onChangeDesignation = (e) => {
    const {
      target: { name, value },
    } = e;
    if (name === "designation" && id && form.trainingDesignation !== value) {
      confirmAlert({
        title: "Please update Training designation",
        message: "Do you want to proceed?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              onChange(e);
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    }
  };

  return (
    <div>
      <div>
        <h5>Basic Details</h5>
        <Row>
          <Col md={4}>
            <FormInput
              name={"firstName"}
              value={form.firstName}
              onChange={onChange}
              label={contractorPersonFormLabel["firstName"]}
              placeHolder={contractorPersonFormLabel["firstName"]}
              error={error["firstName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"middleName"}
              value={form.middleName}
              onChange={onChange}
              label={contractorPersonFormLabel["middleName"]}
              placeHolder={contractorPersonFormLabel["middleName"]}
              error={error["middleName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"lastName"}
              value={form.lastName}
              onChange={onChange}
              label={contractorPersonFormLabel["lastName"]}
              placeHolder={contractorPersonFormLabel["lastName"]}
              error={error["lastName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"authorizedPerson"}
              value={form.authorizedPerson}
              onChange={onChange}
              label={contractorPersonFormLabel["authorizedPerson"]}
              placeHolder={contractorPersonFormLabel["authorizedPerson"]}
              error={error["authorizedPerson"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"laborLicenseNo"}
              value={form.laborLicenseNo}
              onChange={onChange}
              label={contractorPersonFormLabel["laborLicenseNo"]}
              placeHolder={contractorPersonFormLabel["laborLicenseNo"]}
              error={error["laborLicenseNo"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"mobileNumber"}
              type="number"
              value={form.mobileNumber}
              onChange={onChange}
              label={contractorPersonFormLabel["mobileNumber"]}
              placeHolder={contractorPersonFormLabel["mobileNumber"]}
              error={error["mobileNumber"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"aadharNumber"}
              value={form.aadharNumber}
              onChange={onChange}
              label={contractorPersonFormLabel["aadharNumber"]}
              placeHolder={contractorPersonFormLabel["aadharNumber"]}
              error={error["aadharNumber"]}
            />
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["dob"]}</Label>

              <DatePicker
                name={"dob"}
                value={form.dob}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["dob"]}
                placeHolder={contractorPersonFormLabel["dob"]}
                error={error["dob"]}
              />
              <InputError error={error["dob"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["gender"]}</Label>

              <SimpleSelect
                name={"gender"}
                value={form.gender}
                options={contractorPersonGenderList}
                onChange={onChange}
                label="name"
                id="value"
                placeHolder={contractorPersonFormLabel["gender"]}
              />
              <InputError error={error["gender"]} />
            </FormGroup>
          </Col>

          {/* <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["employmentStatus"]}</Label>
              <SimpleSelect
                name={"employmentStatus"}
                value={form.employmentStatus}
                options={contractorPersonEmploymentStatusList}
                onChange={onChange}
                label="name"
                id="value"
                placeHolder={contractorPersonFormLabel["employmentStatus"]}
                error={error["employmentStatus"]}
              />
              <InputError error={error["employmentStatus"]} />
            </FormGroup>
          </Col> */}
          <Col md={4}>
            {/* <FormGroup>
              <Label>{contractorPersonFormLabel["designation"]}</Label> */}

            <FormInput
              name={"designation"}
              value={form?.designation}
              onChange={onChange}
              // options={employeeTrainingDesignationList}
              // label={"name"}
              // id="value"
              label={contractorPersonFormLabel["designation"]}
              placeHolder={contractorPersonFormLabel["designation"]}
            />
            {/* <InputError error={error["designation"]} />
            </FormGroup> */}
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["dateOfJoining"]}</Label>

              <DatePicker
                name={"dateOfJoining"}
                value={form.dateOfJoining}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["dateOfJoining"]}
                placeHolder={contractorPersonFormLabel["dateOfJoining"]}
                error={error["dateOfJoining"]}
                disabled={!form.employmentStatus || form.employmentStatus === "inActive"}
              />
              <InputError error={error["dateOfJoining"]} />
            </FormGroup>
          </Col>

          {!id && (
            <Col md={4}>
              <FormGroup>
                <Label>{contractorPersonFormLabel["contractorId"]}</Label>

                <SimpleSelect
                  name={"contractorId"}
                  value={+form?.contractorId}
                  onChange={onChange}
                  options={contractorList.map((d) => ({
                    name: `${d.contractorLegalEntity}`,
                    value: d.id,
                  }))}
                  label={"name"}
                  id="value"
                  placeHolder={contractorPersonFormLabel["contractorId"]}
                  error={error["contractorId"]}
                  disabled={
                    !form.employmentStatus || form.employmentStatus === "inActive"
                  }
                />
                <InputError error={error["contractorId"]} />
              </FormGroup>
            </Col>
          )}
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["employmentStatus"]}</Label>

              <span>{form.employmentStatus === "inActive" ? "In-Active" : "Active"}</span>
            </FormGroup>
          </Col>
        </Row>
      </div>

      {/* <div className="mt-2">
        <h5>Location</h5>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["contractorId"]}</Label>

              <SimpleSelect
                name={"contractorId"}
                value={form.contractorId}
                onChange={onChange}
                options={contractorList.map((d) => ({
                  name: `${d.contactPerson}`,
                  value: d.id,
                }))}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["contractorId"]}
                error={error["contractorId"]}
                disabled={!form.employmentStatus || form.employmentStatus === "inActive"}
              />
              <InputError error={error["contractorId"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["siteType"]}</Label>

              <SimpleSelect
                name={"siteType"}
                value={form.siteType}
                onChange={onChange}
                options={siteTypeList}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["siteType"]}
                error={error["siteType"]}
                disabled={!form.employmentStatus || form.employmentStatus === "inActive"}
              />
              <InputError error={error["siteType"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["currentWorkLocation"]}</Label>

              <SimpleSelect
                name={"currentWorkLocation"}
                value={form.currentWorkLocation}
                onChange={onChange}
                options={
                  form.siteType
                    ? siteList
                        .filter((d) => d.siteType === +form.siteType)
                        .map((d) => ({
                          name: `${d.name}`,
                          value: d.id,
                        }))
                    : []
                }
                label={"name"}
                disabled={!form.siteType}
                id="value"
                placeHolder={contractorPersonFormLabel["currentWorkLocation"]}
                error={error["currentWorkLocation"]}
              />
              <InputError error={error["currentWorkLocation"]} />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["mineTag"]}</Label>

              <SimpleSelect
                name={"mineTag"}
                value={form.mineTag}
                options={contractorPersonMineTagList}
                onChange={onChange}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["mineTag"]}
                error={error["mineTag"]}
                disabled
              />
              <InputError error={error["mineTag"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["dateOfJoining"]}</Label>

              <DatePicker
                name={"dateOfJoining"}
                value={form.dateOfJoining}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["dateOfJoining"]}
                placeHolder={contractorPersonFormLabel["dateOfJoining"]}
                error={error["dateOfJoining"]}
                disabled={!form.employmentStatus || form.employmentStatus === "inActive"}
              />
              <InputError error={error["dateOfJoining"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["designation"]}</Label>

              <SimpleSelect
                name={"designation"}
                value={form?.designation}
                onChange={id ? onChangeDesignation : onChange}
                options={employeeTrainingDesignationList}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["designation"]}
              />
              <InputError error={error["designation"]} />
            </FormGroup>
          </Col>
           <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["dateOfSeparation"]}</Label>

              <DatePicker
                name={"dateOfSeparation"}
                value={form.dateOfSeparation}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["dateOfSeparation"]}
                placeHolder={contractorPersonFormLabel["dateOfSeparation"]}
                error={error["dateOfSeparation"]}
                disabled={
                  !form.employmentStatus || form.employmentStatus === "active"
                }
              />
              <InputError error={error["dateOfSeparation"]} />
            </FormGroup>
          </Col> 
        </Row>
      </div> */}

      {/* <div className="mt-2">
        <h5>Training</h5>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["trainingDesignation"]}</Label>

              <SimpleSelect
                name={"trainingDesignation"}
                value={+form?.trainingDesignation}
                onChange={id ? onChangeTraining : onChange}
                options={trainingOption}
                label={"label"}
                id="id"
                placeHolder={contractorPersonFormLabel["trainingDesignation"]}
              />
              <InputError error={error["trainingDesignation"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["trainingEligibility"]}</Label>

              <SimpleSelect
                name={"trainingEligibility"}
                value={form.trainingEligibility}
                options={contractorPersonTrainingEligibilityList}
                onChange={onChange}
                placeHolder={contractorPersonFormLabel["trainingEligibility"]}
                label={"name"}
                disabled={!form.trainingDesignation}
                id="value"
              />
              <InputError error={error["trainingEligibility"]} />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["designationChangeTrainingDate"]}</Label>

              <DatePicker
                name={"designationChangeTrainingDate"}
                value={form.designationChangeTrainingDate}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["designationChangeTrainingDate"]}
                placeHolder={contractorPersonFormLabel["designationChangeTrainingDate"]}
                disabled={true}
              />
              <InputError error={error["designationChangeTrainingDate"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>
                {contractorPersonFormLabel["designationChangeTrainingStatus"]}
              </Label>

              <SimpleSelect
                name={"designationChangeTrainingStatus"}
                value={form.designationChangeTrainingStatus}
                onChange={onChange}
                placeHolder={contractorPersonFormLabel["designationChangeTrainingStatus"]}
                options={contractorPersonTrainingStatus}
                label={"name"}
                disabled={true}
                id="value"
              />

              <InputError error={error["designationChangeTrainingStatus"]} />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["basicTrainingCompletionDate"]}</Label>

              <DatePicker
                name={"basicTrainingCompletionDate"}
                value={form.basicTrainingCompletionDate}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["basicTrainingCompletionDate"]}
                placeHolder={contractorPersonFormLabel["basicTrainingCompletionDate"]}
                disabled={id}
              />
              <InputError error={error["basicTrainingCompletionDate"]} />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["lastRefresherTrainingDate"]}</Label>

              <DatePicker
                name={"lastRefresherTrainingDate"}
                value={form.lastRefresherTrainingDate}
                onChangeDate={onChange}
                label={contractorPersonFormLabel["lastRefresherTrainingDate"]}
                placeHolder={contractorPersonFormLabel["lastRefresherTrainingDate"]}
                disabled={id}
              />
              <InputError error={error["lastRefresherTrainingDate"]} />
            </FormGroup>
          </Col>
        </Row>
      </div> */}

      {/* <div className="mt-2">
        <h5>Medical</h5>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["specialMedicalExamCategory"]}</Label>

              <SimpleSelect
                name={"specialMedicalExamCategory"}
                value={form.specialMedicalExamCategory}
                onChange={onChange}
                options={contractorPersonMedicalCategoryList}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["specialMedicalExamCategory"]}
              />
              <InputError error={error["specialMedicalExamCategory"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["specialMedicalExamEligibility"]}</Label>

              <SimpleSelect
                name={"specialMedicalExamEligibility"}
                value={form.specialMedicalExamEligibility}
                onChange={onChange}
                options={contractorPersonMedicalEligibilityList}
                placeHolder={contractorPersonFormLabel["specialMedicalExamEligibility"]}
                disabled={!form.specialMedicalExamCategory}
                label={"name"}
                id="value"
              />
              <InputError error={error["specialMedicalExamEligibility"]} />
            </FormGroup>
          </Col>
        </Row>
      </div> */}

      {!id && (
        <InitialLocationForm
          siteList={siteList}
          form={form}
          onChange={onChange}
          error={error}
          hideMedicalForm
        />
      )}

      {form.siteType === 3 && (
        <>
          {/* {!id && ( */}
          <InitialTrainingForm
            form={form}
            onChange={onChange}
            error={error}
            id={id}
            previousTraining={previousTraining}
            setPreviousTraining={setPreviousTraining}
            preTrainingErr={preTrainingErr}
          />
          {/* )} */}

          <InitialMedicalForm
            showMedical
            form={form}
            onChange={onChange}
            error={error}
            id={id}
            employeeType={"contractorPerson"}
          />
        </>
      )}
    </div>
  );
}

export default ContractorPersonForm;
